

import fisoterapeuta1 from './img/fisioterapeuta1.jpg';
import fiso3 from './img/fiso3.jpg';
import Psicología from './img/psicologia.jpg';
import ondas from './img/onda_de_choques.jpg';
import pie from "./img/pie.jpg";
import mep from "./img/mep.jpg";
import atm from './img/atm.jpg';
import osteo from './img/osteopatia.jpg';
import nutricion from './img/nutricion.jpg';
import trauma from './img/traumatologia.jpg';
import entrenam_pers from './img/entrenamiento_personalizado.jpg';
import masaje_terap from './img/masaje_terapeutico.jpg';
import linfatico from './img/linfatico.jpg';
import presoterapia from './img/presoterapia.jpg';
import ventosas from './img/ventosas.jpg';
import holistica from './img/holistica.jpg';

const defaultImage =
  "https://hips.hearstapps.com/hmg-prod/images/beautiful-young-woman-doing-exercises-and-doing-royalty-free-image-1666943995.jpg?crop=0.667xw:1.00xh;0.150xw,0&resize=1200:*";

export const services = [
  {
    title: "Kinesiología y Fisiatría",
    desc: "Cada sesión combina agentes de fisioterapia con rehabilitación activa a través del movimiento.",
    more:
      "Una disciplina de la salud que trabaja sobre el movimiento humano mediante técnicas de evaluación, tratamiento y rehabilitación.",
    icon: "HeartPulse",
    image: fisoterapeuta1
  },
  {
    title: "RPG (Reeducación Postural Global)",
    desc: "Mejora la postura y alivia dolores crónicos trabajando el cuerpo como un todo.",
    more:
      "Método de reeducación postural basado en estiramientos globales y respiración consciente. " +
      "Ayuda a corregir desequilibrios, mejorar la alineación del cuerpo y aliviar dolores crónicos, abordando cadenas musculares completas y no solo zonas aisladas.",
    icon: "Activity",
    image: fiso3
  },
  {
    title: "Ondas de Choque",
    desc: "Terapia no invasiva para tendinopatías y dolores musculoesqueléticos crónicos.",
    more:
      "Terapia no invasiva que utiliza ondas acústicas de alta energía para estimular la regeneración de tejidos. " +
      "Favorece la reparación, reduce la inflamación, acelera la recuperación y alivia dolores persistentes. " +
      "Indicada en tendinopatías, fascitis plantar, dolores musculoesqueléticos crónicos y calcificaciones.",
    icon: "Sparkles",
    image: ondas
  },
  {
    title: "MEP (Microelectrólisis Percutánea)",
    desc: "Estimula la reparación natural del tejido en lesiones crónicas.",
    more:
      "Técnica mínimamente invasiva que utiliza microcorriente galvánica aplicada con una aguja fina en el tejido lesionado. " +
      "Promueve la reparación natural del tejido, disminuye el dolor y acelera la recuperación. " +
      "Indicada en tendinopatías crónicas, lesiones musculares persistentes, fascitis plantar, epicondilitis/epitrocleitis y otras patologías tendinosas resistentes.",
    icon: "Sparkles",
    image: mep
  },
  {
    title: "Plantillas Personalizadas",
    desc: "Mejoran la pisada, corrigen la postura y alivian molestias al caminar.",
    more:
      "Dispositivos ortopédicos confeccionados según la biomecánica y necesidades de cada paciente. " +
      "Ayudan a mejorar la pisada, corregir la postura y aliviar molestias en pies, rodillas o columna. " +
      "Se adaptan a cada necesidad específica y se entregan en el día.",
    icon: "Activity",
    image: pie
  },
  {
    title: "Psicología",
    desc: "Espacio terapéutico profesional para acompañar procesos emocionales.",
    more:
      "Espacio terapéutico profesional para trabajar emociones, pensamientos y conductas. " +
      "Acompaña procesos personales, manejo del estrés, ansiedad, duelos y otros desafíos cotidianos. " +
      "Enfoque principal en terapia cognitivo-conductual (TCC), orientada a objetivos concretos y herramientas prácticas.",
    icon: "HeartPulse",
    image: Psicología
  },
  {
    title: "Osteopatía",
    desc: "Terapia manual para recuperar equilibrio y movilidad global del cuerpo.",
    more:
      "Terapia manual que actúa sobre músculos, articulaciones y fascias para restablecer el equilibrio global del cuerpo. " +
      "Libera tensiones, mejora la movilidad y acompaña al cuerpo hacia un funcionamiento más armónico, atendiendo el origen de las molestias y no solo el síntoma.",
    icon: "Activity",
    image: osteo
  },
  {
    title: "Nutrición",
    desc: "Mejora de hábitos alimentarios, energía y rendimiento físico.",
    more:
      "Acompañamiento profesional para ordenar la alimentación y cuidar la salud integral. " +
      "Ayuda a mejorar la energía, acompañar cambios físicos y sostener hábitos saludables. " +
      "Incluye nutrición deportiva para profesionales, amateurs o quienes buscan optimizar su rendimiento, prevenir lesiones y mejorar desempeño, con estudio antropométrico completo.",
    icon: "HeartPulse",
    image: nutricion
  },
  {
    title: "ATM (Articulación Temporomandibular)",
    desc: "Abordaje de bruxismo, tensiones mandibulares y dolores asociados.",
    more:
      "Área funcional que comprende la articulación entre mandíbula y cráneo y su musculatura asociada. " +
      "El tratamiento ayuda a aliviar bruxismo, tensiones mandibulares, chasquidos y dolores locales o referidos, restaurando el equilibrio y la movilidad de la zona.",
    icon: "Activity",
    image: atm
  },
  {
    title: "Traumatología",
    desc: "Diagnóstico y tratamiento médico de lesiones óseas, articulares y musculares.",
    more:
      "Especialidad médica dedicada al diagnóstico y tratamiento de lesiones óseas, articulares y musculares. " +
      "Ofrece soluciones precisas y seguras para traumatismos, dolores articulares, lesiones deportivas y patologías del aparato locomotor.",
    icon: "HeartPulse",
    image: trauma
  },
  {
    title: "Kalmares Active (Entrenamiento Personalizado)",
    desc: "Entrenamiento guiado en un espacio cuidado, ideal para continuar después del alta.",
    more:
      "Espacio de entrenamiento guiado por profesionales para quienes prefieren un entorno seguro y personalizado antes que un gimnasio multitudinario. " +
      "Ideal para pacientes que finalizan tratamiento y desean continuar en movimiento. " +
      "Incluye rutinas diseñadas según objetivos, dolencias y patologías, en un ambiente cuidado orientado al bienestar integral.",
    icon: "Activity",
    image: entrenam_pers
  },
  {
    title: "Masajes Terapéuticos",
    desc: "Relajan, descontracturan y revitalizan el cuerpo.",
    more:
      "Conjunto de técnicas manuales destinadas a relajar, descontracturar y revitalizar el cuerpo. " +
      "Ayudan a reducir tensiones, contracturas y mejorar la circulación. " +
      "Incluye masajes relajantes, descontracturantes, con piedras calientes, gel criogénico y masaje deportivo.",
    icon: "HeartPulse",
    image: masaje_terap
  },
  {
    title: "Drenaje Linfático Manual",
    desc: "Estimula el sistema linfático y reduce edemas de forma suave.",
    more:
      "Técnica suave que estimula el sistema linfático mediante maniobras específicas. " +
      "Ayuda a reducir edemas, mejorar la circulación y acompañar procesos postquirúrgicos, aportando alivio y sensación de ligereza.",
    icon: "Sparkles",
    image: linfatico
  },
  {
    title: "Presoterapia",
    desc: "Favorece la circulación y genera alivio en piernas cansadas.",
    more:
      "Terapia que utiliza presión de aire aplicada mediante botas especiales. " +
      "Favorece la circulación, reduce la inflamación y aporta sensación de descanso y alivio, especialmente en casos de piernas cansadas o retención de líquidos.",
    icon: "Activity",
    image: presoterapia
  },
  {
    title: "Terapia con Ventosas",
    desc: "Mobiliza tejidos y libera tensiones mediante succión controlada.",
    more:
      "Técnica tradicional que utiliza copas de succión para movilizar tejidos y liberar tensiones. " +
      "Mejora la circulación, reduce el dolor muscular y ayuda a revitalizar la energía general del cuerpo.",
    icon: "Sparkles",
    image: ventosas
  },
  {
    title: "Terapias Holísticas",
    desc: "Abordan mente, cuerpo y emociones desde una mirada integradora.",
    more:
      "Conjunto de prácticas integradoras como Reiki, Bioneuroemoción y Mindfulness, que trabajan mente, cuerpo y emociones de manera conjunta. " +
      "Ayudan a reducir el estrés, liberar bloqueos emocionales y promover un bienestar profundo y sostenido.",
    icon: "HeartPulse",
    image: holistica
  }
];

export const testimonials = [
  {
    quote:
      "El equipo es súper profesional y humano. Noté cambios muy rápido.",
    author: "Marina Deportista amateur"
  },
  {
    quote:
      "Me acompañaron en todo el proceso de rehabilitación. Volví a entrenar sin dolor.",
    author: "Luciano  Rehabilitación lumbar"
  },
  {
    quote:
      "Espacio hermoso y atención personalizada. Me sentí cuidada desde el primer día.",
    author: "Paula  Cervical / ATM"
  }
];

export const promotions = [
  {
    id: "pack-5-kine",
    title: "Pack x5 sesiones de Kinesiología",
    description:
      "Ideal para quienes necesitan un acompañamiento continuo. Permite avanzar en la rehabilitación con mayor constancia y un valor preferencial."
  },
  {
    id: "pack-10-kine",
    title: "Pack x10 sesiones de Kinesiología",
    description:
      "La opción más conveniente para tratamientos prolongados o procesos de recuperación integral. Mayor ahorro y seguimiento permanente."
  },
  {
    id: "pack-3-ondas",
    title: "Pack x3 sesiones de Ondas de Choque",
    description:
      "Pensado para cuadros que requieren varias aplicaciones para obtener mejores resultados. Optimiza la recuperación con un costo reducido."
  },
  {
    id: "descuento-jubilados",
    title: "Descuentos para Jubilados",
    description:
      "Presentando el carnet de jubilado/a, contamos con descuentos especiales en sesiones individuales o en packs de sesiones. Una manera de acompañar su bienestar con accesibilidad y cuidado."
  }
];
